import axios from 'axios';
import { polusBaseUrl, POST } from '../../../utils/axios-interceptor';
import { HEADERS } from '../../../utils/constants/commonConstants';
import { BucketType, CashflowUnit } from '../../../modules/Dashboard/DashboardModules/Financials/components/FinancialsFromBankingV2/types';

export function fetchBankEntityRationaleService() {
    return axios({
        baseURL: polusBaseUrl,
        url: '/data/bankEntityRationale',
        method: POST,
        data: {},
    });
}

export function fetchBankStatementCashflowBucketsService(window?: { startDate?: string; endDate?: string; accountIds?: string[] }) {
    const hasWindow = !!window?.startDate && !!window?.endDate;
    return axios({
        baseURL: polusBaseUrl,
        url: '/data/bankStatementCashflowBuckets',
        method: POST,
        data: {
            ...(hasWindow ? { startDate: window!.startDate, endDate: window!.endDate } : {}),
            ...(window?.accountIds?.length ? { accountIds: window!.accountIds } : {}),
        },
    });
}

export interface BucketPayload {
    bucketType: BucketType;
    bucketKey: string | null;
    classificationId?: number | null;
    startDate?: string;
    endDate?: string;
    accountIds?: string[];
}

export function fetchBankTransactionsByBucketService(bucket: BucketPayload) {
    return axios({
        baseURL: polusBaseUrl,
        url: '/data/bankTransactionsByBucket',
        method: POST,
        data: bucket,
    });
}

export interface CashflowExportPayload {
    startDate?: string;
    endDate?: string;
    unit: CashflowUnit;
    /** CSV of account ids (the caller joins the selection) — the Unifier substitutes it into the `accountId` query param. */
    accountIds?: string;
}

export function fetchBankStatementCashflowExportService(investeeOrgId: string, payload: CashflowExportPayload) {
    return axios({
        baseURL: polusBaseUrl,
        url: '/unifier/bankStatementCashflowExport',
        method: POST,
        headers: { [HEADERS.X_REQUESTED_ORGANIZATION_ID]: investeeOrgId },
        data: {
            requestPayload: { investeeOrgId, ...payload },
        },
    });
}

export interface EditClassificationEdit {
    entityId: number;
    currentClassificationId: number;
    /** The row's current rationale grain; scopes a rationale SET/clear to that grain on the backend. */
    currentRationale?: string | null;
    classificationId?: number;
    rationale?: string;
    entityName?: string;
    unlink?: boolean;
    targetEntityId?: number;
    clearRationale?: boolean;
    clearClassification?: boolean;
}

export interface OrgEntity {
    entityId: number;
    displayName: string;
    normalizedName: string;
}

export function fetchOrgEntitiesService(investeeOrgId: string) {
    return axios({
        baseURL: polusBaseUrl,
        url: '/unifier/bankEntities',
        method: POST,
        headers: { 'x-requested-organization-id': investeeOrgId },
        data: { requestPayload: { investeeOrgId } },
    });
}

export function editClassificationsService(investeeOrgId: string, edits: EditClassificationEdit[]) {
    return axios({
        baseURL: polusBaseUrl,
        url: '/unifier/editBankClassifications',
        method: POST,
        headers: { 'x-requested-organization-id': investeeOrgId },
        data: { requestPayload: { investeeOrgId, edits } },
    });
}
